module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.Sumitted),
      expression: "!Sumitted"
    }],
    staticClass: "Sumitted_Hidden"
  }, [_c('header', [_c('div', {
    staticClass: "headerTitle"
  }, [_c('h1', {
    staticStyle: {
      "font-weight": "100"
    }
  }, [_c('el-button-group', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-back"
    }
  })], 1)], 1), _vm._v("\n                请填写相关信息\n            ")], 1), _vm._v(" "), _c('el-steps', {
    attrs: {
      "active": 1,
      "finish-status": "success",
      "align-center": ""
    }
  }, [_c('el-step', {
    attrs: {
      "title": "选模板",
      "icon": "el-icon-picture"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "填信息",
      "icon": "el-icon-edit"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "上传",
      "icon": "el-icon-upload"
    }
  })], 1)], 1)]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasShopName || _vm.hasWifi),
      expression: "hasShopName||hasWifi"
    }],
    staticClass: "WriteinfoPanel"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "80px"
    }
  }, [(_vm.hasShopName) ? _c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "ShopName",
      "placeholder": ""
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.getFontPreview
    },
    model: {
      value: (_vm.ruleForm.ShopName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "ShopName", $$v)
      },
      expression: "ruleForm.ShopName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.get_Card_type.indexOf('color') >= 0) ? _c('el-form-item', {
    attrs: {
      "label": "字体颜色",
      "prop": "ShopNameColor",
      "placeholder": ""
    }
  }, [_c('el-color-picker', {
    on: {
      "change": _vm.getFontPreview
    },
    model: {
      value: (_vm.ruleForm.ShopNameColor),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "ShopNameColor", $$v)
      },
      expression: "ruleForm.ShopNameColor"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasShopName),
      expression: "hasShopName"
    }],
    attrs: {
      "label": "店名字体"
    }
  }, [_c('el-cascader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasShopName),
      expression: "hasShopName"
    }],
    attrs: {
      "placeholder": "请选择字体",
      "options": _vm.fontOptions,
      "show-all-levels": false
    },
    on: {
      "change": _vm.getFontPreview
    },
    model: {
      value: (_vm.ruleForm.FontType),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "FontType", $$v)
      },
      expression: "ruleForm.FontType"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.fontPreviewDataURL,
      "id": "fontPreview"
    }
  })], 1), _vm._v(" "), (_vm.hasWifi) ? _c('el-form-item', {
    attrs: {
      "label": "WiFi账号",
      "prop": "wifiAccount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "中文8个字内,英文12个字内"
    },
    on: {
      "blur": _vm.getQrcodePreview
    },
    model: {
      value: (_vm.ruleForm.wifiAccount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "wifiAccount", $$v)
      },
      expression: "ruleForm.wifiAccount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasWifi) ? _c('el-form-item', {
    attrs: {
      "label": "WiFi密码",
      "prop": "wifiPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "长度建议小于14位"
    },
    on: {
      "blur": _vm.getQrcodePreview
    },
    model: {
      value: (_vm.ruleForm.wifiPassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "wifiPassword", $$v)
      },
      expression: "ruleForm.wifiPassword"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "WriteinfoPanel"
  }, [_c('p', {
    staticClass: "section_title"
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v("你需要上传"), _c('span', {
    staticClass: "hightlightText"
  }, [_vm._v(_vm._s(_vm.CardQrcodeCount))]), _vm._v("个二维码"), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLoading),
      expression: "isShowLoading"
    }],
    staticClass: "upload-Loading"
  }, [_c('i', {
    staticClass: "el-icon-loading",
    staticStyle: {
      "font-size": "2em"
    }
  }), _c('p', [_vm._v("智能识别中...")])])]), _vm._v(" "), _c('el-upload', {
    ref: "eleupload",
    attrs: {
      "list-type": "picture-card",
      "drag": "",
      "accept": "image/jpeg,image/png",
      "action": "/api/uploadImgAndGetURL/",
      "auto-upload": true,
      "on-success": _vm.handlePictureSuccess,
      "on-error": _vm.handlePictureError,
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.fileList,
      "multiple": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("仅支持jpg/png格式，且小于5MB的清晰图片")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "WriteinfoPanel"
  }, [_c('p', {
    staticClass: "section_title"
  }, [_c('i', {
    staticClass: "el-icon-picture"
  }), _vm._v("预览模板：" + _vm._s(this.$store.getters.get_Card_type) + " ")]), _vm._v(" "), _c('img', {
    staticClass: "card-img",
    attrs: {
      "src": _vm.qrcodePreviewDataURL,
      "alt": this.$store.getters.get_Card_type + '型号模板'
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "WriteinfoPanel"
  }, [_vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "auto"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "旺旺名称",
      "prop": "WangWangID"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.ruleForm.WangWangID),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "WangWangID", $$v)
      },
      expression: "ruleForm.WangWangID"
    }
  })], 1)], 1), _vm._v(" "), _c('Button', {
    staticClass: "submit_btn",
    class: {
      'submit_btn_disabled': !this.ruleForm.WangWangID.trim() != ''
    },
    attrs: {
      "disabled": this.ruleForm.WangWangID.trim() == ''
    },
    on: {
      "click": _vm.submitQrcode
    }
  }, [_vm._v("\n        完成\n      ")])], 1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "section_title"
  }, [_c('i', {
    staticClass: "el-icon-edit"
  }), _vm._v("模板信息")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "section_title"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v("买家信息")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "WriteinfoPanel"
  }, [_c('p', {
    staticClass: "section_title"
  }, [_c('i', {
    staticClass: "el-icon-star-on"
  }), _vm._v("客户须知")]), _vm._v(" "), _c('ul', {
    staticClass: "userTips"
  }, [_c('li', [_vm._v("为了防止出现错漏，提交后请"), _c('span', {
    staticClass: "hightlightText"
  }, [_vm._v("注意跟客服进行确认")]), _vm._v("。")]), _vm._v(" "), _c('li', [_vm._v("诚信木匠提供服务")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7958bab3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WriteInfo.vue
// module id = 205
// module chunks = 1